/* unplugin-vue-components disabled */import script from "./CommonTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommonTable.vue?vue&type=script&lang=ts&setup=true"

import "./CommonTable.vue?vue&type=style&index=0&id=3b030c97&scoped=true&lang=less"

import exportComponent from "D:\\workspace\\home-power-station\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b030c97"]])

export default __exports__